
export default {
  name: 'links',
  components: {

  },
  data() {
    return {
      userInfo: {}
    }
  },
  created() {

  },
  mounted: function () {
    this.getInfo()
  },
  methods: {
    getInfo: function (code) {
      this.apiGet('/h5/api/user/getUserInfo', '', res => {
        if (res.state) {
          this.userInfo = res.data
        } else {
        }
      })
    },
    toHb: function() {
      this.$message('正在开发')
    },
    toMy: function () {
      this.$router.push({ path: '/my' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toBindAli: function () {
      this.$router.push({ path: '/bindAli' })
    },
    toList: function () {
      this.$router.push({ path: '/list' })
    }
    // /h5/api/user/setAlipay
  }

}



// WEBPACK FOOTER //
// ./src/views/links/links.js